<template>
  <v-container>
    <v-row>
      <v-col cols="12" >
        <v-img
          :src="require('@/assets/banner-finantare_alt.png')"
          class="mx-auto"
          contain
          max-height="150px">
        </v-img>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-parallax src="/img/hero.jpg" height="700">
          <v-row align="center">
            <v-col class="text-left" cols="12" lg="8">
              <h1 class="text-lg-h2 text-h4 mb-4 text-left blue--text text--darken-2 font-weight-normal" style="text-shadow: 4px 4px #ffffff">
                <!-- „S.E.S. – Solidaritate, <br> Egalitate, <br> Sustenabilitate" -->
                <img src="/img/title.png" :width="$vuetify.breakpoint.name === 'xs' ? '100%' : '50%'" />
              </h1>
              <p class="text-lg-body-1 text-body-2 black--text">
                Cod SMIS 128078
              </p>
              <p class="text-lg-body-1 text-body-2 black--text">
                Proiect cofinantat din Fondul Social European prin Programul Operational Capital Uman,
              </p>
              <p class="text-lg-body-1 text-body-2 black--text">
                Axa prioritara 4: Incluziunea sociala si combaterea saraciei
              </p>
              <v-layout row>
                <v-flex xs12>
                  <v-btn :to="user ? '/personal' : '/signin'" color="primary" class="mr-2">
                    {{ user ? 'Spre contul tau' : 'Autentificare' }}
                    <template v-slot:loader>
                      <span class="custom-loader">
                        <v-icon light>mdi-cached</v-icon>
                      </span>
                    </template>
                  </v-btn>
                  <template v-if="!user">
                    <span class="black--text">sau</span>
                    <v-btn to="/signup" color="primary" class="ml-2" disabled>
                      Creare cont
                      <template v-slot:loader>
                        <span class="custom-loader">
                          <v-icon light>mdi-cached</v-icon>
                        </span>
                      </template>
                    </v-btn>
                  </template>
                </v-flex>
              </v-layout>
            </v-col>
          </v-row>
        </v-parallax>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h5 class="text-h5 text-center my-4">
          Resurse &amp; Anunturi
        </h5>

        <v-slide-group
          v-model="resursa"
          class="pa-4"
          show-arrows>
          <v-slide-item v-slot:default="{ active, toggle }" v-for="item in resources" :key="item.id">
            <v-hover v-slot:default="{ hover }">
              <v-card
                :color="active ? 'primary lighten-2' : 'grey lighten-4'"
                class="ma-4"
                :elevation="hover ? 4 : 2"
                height="200"
                width="200"
                @click="toggle">
                <v-img
                  :class="{ 'card-image-hover': hover || active }"
                  class="primary--text align-end card-image"
                  height="200px"
                  :src="item.thumb || require('@/assets/file_cabinet.jpg')">
                  <v-expand-transition>
                    <div
                      v-if="hover"
                      class="d-flex transition-fast-in-fast-out primary v-card--reveal text-h6 text-center white--text"
                      style="height: 100%;">
                      {{ item.title }}
                    </div>
                  </v-expand-transition>
                </v-img>
              </v-card>
            </v-hover>
          </v-slide-item>
        </v-slide-group>

        <v-expand-transition>
          <v-sheet color="grey lighten-4" tile>
            <template v-if="resursa != null">
              <div class="ma-0 pa-2" align="center" justify="center">
                <h3 class="title">
                  {{ resources[resursa].title }}
                </h3>
                <div v-html="resources[resursa].content"></div>
                <a :href="resources[resursa].file" target="_blank" download v-if="resources[resursa].file" style="text-decoration: none">
                  Descarca
                  <v-icon right color="primary">
                    mdi-download
                  </v-icon>
                </a>
              </div>
            </template>
            <template v-else>
              <v-alert type="info">
                Click pe o resursa pentru a putea vedea informatii despre ea si pentru a o putea descarca.
              </v-alert>
            </template>
          </v-sheet>
        </v-expand-transition>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h5 class="text-h5 text-center my-4">
          Cum particip?
        </h5>
        <v-stepper>
          <v-stepper-header>
            <v-stepper-step editable step="1">Cititi documentatia proiectului</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step editable step="2">Creati un cont</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step editable step="3">Completati formularul de participare</v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card flat>
                <v-card-text class="text-center">
                  <video width="100%" controls src="/media/resurse.mkv"></video>
                </v-card-text>
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="2">
              <v-card flat>
                <v-card-text class="text-center">
                  <video width="100%" controls src="/media/cont.mkv"></video>
                </v-card-text>
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="3">
              <v-card flat>
                <v-card-text class="text-center">
                  <video width="100%" controls src="/media/formular.mkv"></video>
                </v-card-text>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Home",

  data: () => ({
    resursa: null
  }),

  computed: {
    user() {
      return this.$store.state.user;
    },
    resources() {
      return this.$store.getters.resourcesAllItems;
    }
  },

  mounted() {
    this.$store.dispatch("fetchAllFaq");
    this.$store.dispatch("fetchAllResources");
  }
}
</script>